<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: { type: String, required: true },
  placement: { type: String, default: 'top' },
})

const placementClass = computed(
  () =>
    ({
      top: 'bottom-full left-1/2 mb-2 -translate-x-1/2',
      bottom: 'left-1/2 top-full mt-2 -translate-x-1/2',
      'bottom-start': 'left-0 top-full mt-2',
      left: 'right-full top-1/2 mr-2 -translate-y-1/2',
      right: 'left-full top-1/2 ml-2 -translate-y-1/2',
    })[props.placement] || 'bottom-full left-1/2 mb-2 -translate-x-1/2'
)
</script>

<template>
  <span class="group/tooltip relative inline-flex">
    <slot />
    <span
      role="tooltip"
      class="pointer-events-none absolute z-[100] whitespace-nowrap rounded-md bg-[#152745] px-2 py-1 text-[10px] font-semibold text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover/tooltip:opacity-100 group-focus-within/tooltip:opacity-100"
      :class="placementClass"
    >
      {{ text }}
    </span>
  </span>
</template>
